import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import QuestionCircleIcon from '@flipster/react/icon/generated/QuestionCircleIcon';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { NumberInput } from '@flipster/ui';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { symbolBunja } from '../../perpetual/bunja/base';
import { spotFormBunja } from '../bunja/form';
import { formItem, label, labelWrapper } from '../styles';

const LimitPriceForm = () => {
  const transTrade = useTranslations('Trade.r251104');
  const transTradeLimit = useTranslations('Trade.r251104');

  const { symbolInfoWithDefaultAtom } = useBunja(tradeSymbolBunja);
  const { limitPriceAtom, isBboAtom, resetLimitPrice } = useBunja(spotFormBunja);

  const symbolInfo = useAtomValue(symbolInfoWithDefaultAtom);
  const [limitPrice, setLimitPrice] = useAtom(limitPriceAtom);
  const [isBbo, setIsBbo] = useAtom(isBboAtom);
  const { symbol } = useBunja(symbolBunja);

  const { pricePrecision } = symbolInfo;

  return (
    <>
      <div className={labelWrapper}>
        <div className={flex({ justify: 'space-between' })}>
          <span className={label}>{transTrade('Limit_price')}</span>
          <div>
            <Checkbox
              checked={isBbo}
              onChange={(e) => {
                setIsBbo(e.target.checked);
                if (!e.target.checked) resetLimitPrice();
                segment.track(TradeEvent.OrderBboClick, { symbol, checkbox_click: e.target.checked });
              }}
            >
              <div className={css({ display: 'flex', gap: 4, alignItems: 'center', textStyle: 'Text/L/Strong' })}>
                BBO
                <Tooltip placement='bottom-end' shape='white' maxWidth={238}>
                  <Tooltip.Trigger css={{ h: 16 }}>
                    <QuestionCircleIcon size={16} color={token('colors.content.default.level-2')} />
                  </Tooltip.Trigger>
                  <Tooltip.Content>
                    <h6 className={css({ textStyle: 'Text/S/Strong' })}>{transTrade('What_s_bbo')}</h6>
                    <p className={css({ textStyle: 'Text/S/Regular' })}>
                      {transTrade('Limit_price_follows_best_ask_bid_when_buying_selling')}
                    </p>
                  </Tooltip.Content>
                </Tooltip>
              </div>
            </Checkbox>
          </div>
        </div>
      </div>
      <div className={formItem}>
        {isBbo ? (
          <div
            className={flex({
              justify: 'space-between',
              align: 'center',
              height: 50,
              p: 16,
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: 'border.default.level-2',
              borderRadius: 4,
            })}
          >
            <div>{transTradeLimit('Best_counterparty')}</div>
            <span className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-5' })}>
              {symbolInfo.quoteCurrency}
            </span>
          </div>
        ) : (
          <NumberInput
            value={limitPrice}
            name='limitPrice'
            precision={pricePrecision}
            currency={symbolInfo.quoteCurrency}
            onChange={(p) => setLimitPrice(p || '0')}
          />
        )}
      </div>
    </>
  );
};

export default LimitPriceForm;
